import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import Logomark from '../../assets/images/Logomark.png';
import { ROUTES } from 'src/constants/routes';
import Container from '../Container';
import { Box, Grid } from '@mui/material';
import RectangleBox from '../Compliance/RectangleBox';
import SuccessCheckCircleIcon from '../Icons/SuccessCheckCircleIcon';

const coverageBlockMessages = [
  {
    title: 'Policy Found',
    description: 'Your policy meets all requirements',
  },
  {
    title: 'Active Policy',
    description: 'Your policy is currently active.',
  },
  {
    title: 'Correct Name',
    description: 'Your name is the same as on the lease.',
  },
  {
    title: 'Correct Address',
    description: 'Your address is correct.',
  },
  {
    title: 'Personal Liability Coverage',
    description: 'Your coverage meets the requirement.',
  },
  {
    title: 'Personal Property Coverage',
    description: 'Your coverage meets the requirement.',
  },
];

const CoverageCompliant = () => {
  return (
    <Container smPaddings={true}>
      <ConfirmationWithBackButton
        title="Your policy is compliant"
        subtitle="Thank you for linking your renters insurance policy. Your policy details have been verified and shared with your landlord. No further action is required at this time."
        goBackLink={ROUTES.COMPLIANCE_WELCOME_PATH}
        message={(
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            mt: 4
          }}>
            <Box maxWidth="730px">
              <Grid
                container={true}
                margin="auto"
                justifyContent="center"
                gap={3}
              >
                {coverageBlockMessages.map(({ title, description }) => (
                  <Grid item={true} xs={12} key={title}>
                    <RectangleBox
                      propertyName={title}
                      propertyValue={description}
                      statusIcon={(
                        <SuccessCheckCircleIcon
                          height="30px"
                          width="30px"
                        />
                      )}
                    />
                  </Grid>
                ))}

              </Grid>
            </Box>
          </Box>
        )}
        bottomMessage={(
          <Box mt={4}>
            <MessageBox
              image={Logomark}
              title="Still have question?"
            />
          </Box>
        )}
      />
    </Container>
  );
};

export default CoverageCompliant;
